import React from "react";
 // import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
 

export default () => {
  return (
    <>
       <Header />
       <ContactUsForm />
      <Footer /></>
   );
};
